import React from 'react';

const DataRow = ({ item, onValueChange, error }) => {
  const isDirty = item.value !== '';
  const isValid = isDirty && error === '';
  const inputClassName = `data-row-input ${error ? 'data-row-input-error' : ''} ${isValid ? 'data-row-input-valid' : ''}`;
  const title = item.description;

  return (
    <tr className="data-row">
      <td className="data-row-name-cell">{item.name}</td>
      <td className="data-row-value-cell" title={title}>
        <textarea
          value={item.value}
          onChange={(e) => onValueChange(e.target.value)}
          className={inputClassName}
          rows={1}
        />
        {error && <div className="data-row-error-message">{error}</div>}
      </td>
      <td className="data-row-preview-cell">{item.preview}</td>
      <td className="data-row-preview-cell">{item.labelNumber}</td>
      <td className="data-row-preview-cell">{item.pageNum}</td>
    </tr>
  );
};

export default DataRow;